import {Stack} from "@mui/material";
import {Navigate, useParams} from "react-router";
import {appSession} from "../../../TR3AD.ts";
import WidgetHeader from "../../../widgets/WidgetHeader.tsx";
import FeatureAccessMessage from "../../../widgets/FeatureAccessMessage.tsx";
import {appStyles} from "../../../AppStyles.ts";

function UXDashboardSelect() {
    const { networkUID } = useParams();

    return (
        <Stack direction="column" width="100%" minHeight="100vh">
            {appSession.activeSession() === false ? (
                <Navigate to="/" />
            ) : (
                <Stack direction="column" spacing={1} width="99%" >
                    <WidgetHeader
                        title="Dashboards"
                        breadcrumbs={[
                        {
                            display: "Networks",
                            linkTo: `/networks/`,
                            activeView: false
                        },
                        {
                            display: String(networkUID),
                            linkTo: `/networks/${networkUID}`,
                            activeView: false
                        },
                        {
                            display: "Dashboards",
                            linkTo: "",
                            activeView: true
                        }]}
                    />
                    <Stack
                        sx={appStyles.sectionBox}
                        spacing={2}
                        width="100%"
                        minHeight="70vh"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <FeatureAccessMessage />
                    </Stack>
                </Stack>
            )}
        </Stack>
    );
}

export default UXDashboardSelect;
